import React from 'react';
import { Camera } from 'lucide-react';
import PlayerAvatar from './PlayerAvatar';

const PhotoAvatarButton = ({
  imageUrl,
  name,
  size = 'md',
  onClick,
  disabled = false,
  className = '',
  showCamera = true
}) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={`relative inline-flex items-center justify-center ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'} ${className}`}
    title="Cambiar foto"
    aria-label="Cambiar foto"
  >
    <PlayerAvatar imageUrl={imageUrl} name={name} size={size} />
    {showCamera && (
      <span className="absolute -bottom-1 -right-1 bg-black text-white p-1 rounded-full shadow-lg">
        <Camera size={12} />
      </span>
    )}
  </button>
);

export default PhotoAvatarButton;
